export default __webpack_public_path__ + "static/media/GTL.3aa07e45.svg";